import React, { CSSProperties, useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";

const expansionDelayMSec = 400;

export interface VisibilityTransitionProps {
  showIf: boolean;
  children: JSX.Element;
}

export default function VisibilityTransition(props: VisibilityTransitionProps): JSX.Element {
  const refWrapper = useRef<HTMLDivElement>();
  const [isShowing, setIsShowing] = useState<boolean | null>(null);

  const [style, setStyle] = useState<CSSProperties>({});

  useEffect(() => {
    if (props.showIf) {
      // Hide -> Show transition
      setStyle({ maxHeight: "0" });
      setIsShowing(true);

      setTimeout(() => {
        if (refWrapper.current) {
          setStyle({ maxHeight: refWrapper.current.scrollHeight });
        }

        // Clear max-height so that content's height isn't restricted if it changes
        setTimeout(() => {
          // Due to what seems liek a bug in React setting maxHeight to auto is not taking effect here
          // Clearing the style and then setting it works
          setStyle({});
          setStyle({ maxHeight: "auto" });
        }, expansionDelayMSec + 200);
      }, 10);
    } else {
      if (isShowing == null) {  // Initial render
        setIsShowing(false);
      } else {
        // Show -> Hide transition
        if (refWrapper.current) {
          setStyle({ maxHeight: refWrapper.current.scrollHeight });
        }
        setTimeout(() => {
          setStyle({ maxHeight: "0" });
          setTimeout(() => {
            setIsShowing(false);
          }, expansionDelayMSec);
        }, 10);
      }
    }
  }, [!!props.showIf]);

  return <Wrapper ref={refWrapper} style={style} className={isShowing ? "" : "content-hidden"}>
    {isShowing && props.children}
  </Wrapper>
}

const Wrapper = styled.div`
  transition: max-height ${expansionDelayMSec}ms ease-out;
  overflow: hidden;

  /* Ensure this element doesn't add any padding or margin when contents are hidden */
  &&.content-hidden {
    padding: 0;
    margin: 0;
  }
`;
